export const QUEUE_PATH = '/queue/:page?';

export const QUEUE_BASE_PATH = '/queue';
export const QUEUE_MASTER_CASES = undefined; // lol javascript
export const QUEUE_CASES_TO_REVIEW = 'new';
export const QUEUE_ADVERSE_EVENT = 'ae';
export const QUEUE_MEDICAL_INQUIRY = 'mi';
export const QUEUE_PRODUCT_QUALITY = 'pq';
export const QUEUE_YOUR_CASES = 'yours';
